import React from 'react';
import { Link } from 'react-router-dom';
import { Sprout, Shield, Zap, Truck, Coffee, ChevronRight } from 'lucide-react';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section 
        className="relative h-[200px] sm:h-[300px] md:h-[500px] lg:h-[600px] flex items-center justify-center text-white"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_8b43b00b-d49b-410d-b712-afa38bbd140c/artifacts/f51v6qs4_Design%20sem%20nome%20%2832%29.jpg)',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#f3f4f6',
        }}
      >
      </section>

      {/* Filiais Section */}
      <section className="py-12 md:py-20 text-white" style={{ backgroundColor: '#1E3A8A' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-5xl font-bold mb-8 md:mb-12 text-center">NOSSAS UNIDADES</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
            {/* Vilhena - Matriz */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl overflow-hidden hover:bg-opacity-20 transition-all">
              <div className="relative h-32">
                <img src="https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/jtbzkk4m_ChatGPT%20Image%2025%20de%20jun.%20de%202026%2C%2016_02_00.png" alt="Vilhena - Nova Matriz" className="w-full h-full object-cover" />
                <div className="absolute top-2 right-2 bg-green-600 text-white px-2 py-1 rounded text-xs font-bold">MATRIZ</div>
              </div>
              <div className="p-3 text-center">
                <h3 className="font-bold text-base">Vilhena</h3>
                <p className="text-xs text-gray-300 mb-2">RO</p>
                <a 
                  href="https://maps.app.goo.gl/hgTRX248WvQJjyaLA"
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded transition-colors w-full"
                >
                  Ver no Mapa
                </a>
                <a 
                  href="https://wa.me/5569996010407"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded transition-colors w-full mt-1"
                >
                  Falar com Gerente
                </a>
              </div>
            </div>
            
            {/* Cacoal */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl overflow-hidden hover:bg-opacity-20 transition-all">
              <div className="relative h-32">
                <img src="https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/urnlwo1g_cacoal%202026.jpg" alt="Cacoal" className="w-full h-full object-cover" />
              </div>
              <div className="p-3 text-center">
                <h3 className="font-bold text-base">Cacoal</h3>
                <p className="text-xs text-gray-300 mb-2">RO</p>
                <div className="flex flex-col gap-1 items-center">
                  <a 
                    href="https://www.google.com/maps/search/?api=1&query=Av+Castelo+Branco+18592+Cacoal+RO" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded transition-colors w-full"
                  >
                    Ver no Mapa
                  </a>
                  <a 
                    href="https://wa.me/5569992753333"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded transition-colors w-full"
                  >
                    Falar com Gerente
                  </a>
                </div>
              </div>
            </div>
            
            {/* Pontes e Lacerda */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl overflow-hidden hover:bg-opacity-20 transition-all">
              <div className="relative h-32">
                <img src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/e2qbu7le_14%20i.jpg" alt="Pontes e Lacerda" className="w-full h-full object-cover" />
              </div>
              <div className="p-3 text-center">
                <h3 className="font-bold text-base">Pontes e Lacerda</h3>
                <p className="text-xs text-gray-300 mb-2">MT</p>
                <div className="flex flex-col gap-1 items-center">
                  <a 
                    href="https://www.google.com/maps/search/?api=1&query=Av+Valdemar+Bittencourt+290B+Jardim+Bela+Vista+Pontes+e+Lacerda+MT" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded transition-colors w-full"
                  >
                    Ver no Mapa
                  </a>
                  <a 
                    href="https://wa.me/5565996008340"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded transition-colors w-full"
                  >
                    Falar com Gerente
                  </a>
                </div>
              </div>
            </div>
            
            {/* São Miguel do Guaporé */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl overflow-hidden hover:bg-opacity-20 transition-all">
              <div className="relative h-32">
                <img src="https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/jg8avp20_smg%202026.jpg" alt="São Miguel do Guaporé" className="w-full h-full object-cover" />
              </div>
              <div className="p-3 text-center">
                <h3 className="font-bold text-base">São Miguel do Guaporé</h3>
                <p className="text-xs text-gray-300 mb-2">RO</p>
                <div className="flex flex-col gap-1 items-center">
                  <a 
                    href="https://www.google.com/maps/search/?api=1&query=Av+Aluizio+Pinheiro+610+Liberdade+Sao+Miguel+do+Guapore+RO" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded transition-colors w-full"
                  >
                    Ver no Mapa
                  </a>
                  <a 
                    href="https://wa.me/5569984474778"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded transition-colors w-full"
                  >
                    Falar com Gerente
                  </a>
                </div>
              </div>
            </div>
            
            {/* Ariquemes */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl overflow-hidden hover:bg-opacity-20 transition-all">
              <div className="relative h-32">
                <img src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/e1je7ftn_12%20i.jpg" alt="Ariquemes" className="w-full h-full object-cover" />
              </div>
              <div className="p-3 text-center">
                <h3 className="font-bold text-base">Ariquemes</h3>
                <p className="text-xs text-gray-300 mb-2">RO</p>
                <div className="flex flex-col gap-1 items-center">
                  <a 
                    href="https://www.google.com/maps/search/?api=1&query=BR+364+3839+Ariquemes+RO" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded transition-colors w-full"
                  >
                    Ver no Mapa
                  </a>
                  <a 
                    href="https://wa.me/5569984617269"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded transition-colors w-full"
                  >
                    Falar com Gerente
                  </a>
                </div>
              </div>
            </div>
            
            {/* Cerejeiras */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl overflow-hidden hover:bg-opacity-20 transition-all">
              <div className="relative h-32">
                <img src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/ui9bnqne_11%20i.jpg" alt="Cerejeiras" className="w-full h-full object-cover" />
              </div>
              <div className="p-3 text-center">
                <h3 className="font-bold text-base">Cerejeiras</h3>
                <p className="text-xs text-gray-300 mb-2">RO</p>
                <div className="flex flex-col gap-1 items-center">
                  <a 
                    href="https://www.google.com/maps/search/?api=1&query=Cultivar+Agricola+Cerejeiras+RO" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded transition-colors w-full"
                  >
                    Ver no Mapa
                  </a>
                  <a 
                    href="https://wa.me/5569993751423"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded transition-colors w-full"
                  >
                    Falar com Gerente
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="text-center mt-10">
            <Link to="/localizacao" className="inline-flex items-center text-green-400 hover:text-green-300 font-semibold text-lg">
              Ver todas as unidades <ChevronRight className="ml-2" />
            </Link>
          </div>
        </div>
      </section>

      {/* Produtos e Serviços */}
      <section className="py-12 md:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-5xl font-bold text-green-600 mb-4 text-center">PRODUTOS E SERVIÇOS</h2>
          <p className="text-center text-gray-600 mb-8 md:mb-12 max-w-3xl mx-auto text-sm md:text-base">
            Na Cultivar, fornecemos tudo o que sua lavoura precisa para crescer forte e produtiva: defensivos, adubos e sementes de qualidade. Parceiro do produtor do início ao fim da safra!
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
            {/* Sementes */}
            <div className="bg-white rounded-lg p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow text-center">
              <div className="bg-green-100 w-14 h-14 md:w-20 md:h-20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <Sprout className="w-7 h-7 md:w-10 md:h-10 text-green-600" />
              </div>
              <h3 className="text-base md:text-xl font-bold text-gray-800 mb-2">Sementes</h3>
              <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-4 hidden sm:block">Sementes de alta qualidade para sua produção</p>
              <Link to="/produtos?categoria=sementes" data-testid="home-card-sementes" className="inline-block bg-green-600 text-white px-3 md:px-4 py-2 rounded-lg hover:bg-green-700 transition-colors text-xs md:text-sm font-semibold">
                VER CATÁLOGO
              </Link>
            </div>

            {/* Defensivos */}
            <div className="bg-white rounded-lg p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow text-center">
              <div className="bg-blue-100 w-14 h-14 md:w-20 md:h-20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <Shield className="w-7 h-7 md:w-10 md:h-10 text-blue-600" />
              </div>
              <h3 className="text-base md:text-xl font-bold text-gray-800 mb-2">Defensivos</h3>
              <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-4 hidden sm:block">Proteção completa para suas culturas</p>
              <Link to="/produtos?categoria=defensivos" data-testid="home-card-defensivos" className="inline-block bg-green-600 text-white px-3 md:px-4 py-2 rounded-lg hover:bg-green-700 transition-colors text-xs md:text-sm font-semibold">
                VER CATÁLOGO
              </Link>
            </div>

            {/* Fertilizantes */}
            <div className="bg-white rounded-lg p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow text-center">
              <div className="bg-yellow-100 w-14 h-14 md:w-20 md:h-20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <Zap className="w-7 h-7 md:w-10 md:h-10 text-yellow-600" />
              </div>
              <h3 className="text-base md:text-xl font-bold text-gray-800 mb-2">Fertilizantes</h3>
              <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-4 hidden sm:block">Nutrição adequada para melhor produtividade</p>
              <Link to="/produtos?categoria=fertilizantes" data-testid="home-card-fertilizantes" className="inline-block bg-green-600 text-white px-3 md:px-4 py-2 rounded-lg hover:bg-green-700 transition-colors text-xs md:text-sm font-semibold">
                VER CATÁLOGO
              </Link>
            </div>

            {/* Agricultura de Precisão */}
            <div className="bg-white rounded-lg p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow text-center">
              <div className="bg-purple-100 w-14 h-14 md:w-20 md:h-20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <Truck className="w-7 h-7 md:w-10 md:h-10 text-purple-600" />
              </div>
              <h3 className="text-base md:text-xl font-bold text-gray-800 mb-2">Agricultura de Precisão</h3>
              <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-4 hidden sm:block">Tecnologia avançada para sua lavoura</p>
              <Link to="/produtos-servicos#agricultura-precisao" className="inline-block bg-green-600 text-white px-3 md:px-4 py-2 rounded-lg hover:bg-green-700 transition-colors text-xs md:text-sm font-semibold">
                ORÇAMENTO
              </Link>
            </div>

            {/* Café */}
            <div className="bg-white rounded-lg p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow text-center">
              <div className="bg-amber-100 w-14 h-14 md:w-20 md:h-20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <Coffee className="w-7 h-7 md:w-10 md:h-10 text-amber-700" />
              </div>
              <h3 className="text-base md:text-xl font-bold text-gray-800 mb-2">Café</h3>
              <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-4 hidden sm:block">Cultivar Café — comercialização e qualidade</p>
              <Link to="/cultivar-cafe" className="inline-block bg-green-600 text-white px-3 md:px-4 py-2 rounded-lg hover:bg-green-700 transition-colors text-xs md:text-sm font-semibold">
                SAIBA MAIS
              </Link>
            </div>

            {/* Cultivar Log */}
            <div className="bg-white rounded-lg p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow text-center" data-testid="home-card-cultivar-log">
              <div className="bg-blue-100 w-14 h-14 md:w-20 md:h-20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <Truck className="w-7 h-7 md:w-10 md:h-10 text-blue-600" />
              </div>
              <h3 className="text-base md:text-xl font-bold text-gray-800 mb-2">Cultivar Log</h3>
              <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-4 hidden sm:block">Transportadora própria — cobertura nacional</p>
              <Link to="/cultivar-log" className="inline-block bg-green-600 text-white px-3 md:px-4 py-2 rounded-lg hover:bg-green-700 transition-colors text-xs md:text-sm font-semibold">
                SAIBA MAIS
              </Link>
            </div>
          </div>

          <div className="text-center mt-10 md:mt-14">
            <Link
              to="/produtos"
              data-testid="home-ver-catalogo-completo"
              className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 md:py-4 md:px-10 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-sm md:text-base"
              style={{ backgroundColor: '#0072D6' }}
            >
              VER CATÁLOGO COMPLETO
              <ChevronRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-20 bg-green-600 text-white text-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6">Pronto para cultivar bons negócios?</h2>
          <p className="text-base md:text-xl mb-6 md:mb-8">Entre em contato conosco e descubra como podemos ajudar sua produção a crescer!</p>
          <Link
            to="/contato"
            className="inline-block bg-white text-green-600 hover:bg-gray-100 font-bold py-3 px-6 md:py-4 md:px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-base md:text-lg"
          >
            FALE CONOSCO
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;